import { LayoutWithTitleAndInfo, LayoutWithTitleAndInfoProps } from '.'

export interface TitledSectionProps
  extends Pick<LayoutWithTitleAndInfoProps, 'addTopPadding' | 'children'> {
  text?: string
  translationid?: string
}

export const TitledSection = ({
  addTopPadding,
  children,
  text,
  translationid
}: TitledSectionProps) => {
  return (
    <LayoutWithTitleAndInfo
      addTopPadding={addTopPadding}
      titleTranslationTopText={text}
      titleTranslationTopId={translationid}
    >
      {children}
    </LayoutWithTitleAndInfo>
  )
}
